'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from "angular";
import OkvedsController from "./controller/okveds";
import OkvedModalCreateController from "./controller/okvedModalCreate";
import OkvedModalSelectController from "./controller/okvedModalSelect";
import OkvedTableDirective from "./directive/okvedTable";
import OkvedTreeDirective from "./directive/okvedTree";
import OkvedNodeDirective from "./directive/okvedNode";
import OkvedSelectDirective from "./directive/okvedSelect";
import OkvedService from "./service/okved";

export default angular.module('investmentProject.okved', [])
    .controller('OkvedsController', OkvedsController)
    .controller('OkvedModalCreateController', OkvedModalCreateController)
    .controller('OkvedModalSelectController', OkvedModalSelectController)
    .directive('okvedTable', OkvedTableDirective)
    .directive('okvedTree', OkvedTreeDirective)
    .directive('okvedNode', OkvedNodeDirective)
    .directive('okvedSelect', OkvedSelectDirective)
    .factory('OkvedService', OkvedService)
    .name;